// import My from '@/view/my/Index.vue'
import { NativeTabNavigatoLayout } from '@/layout'
import Lawyer from '@/view/lawyer/Index.vue'

const routes = [
  {
    path: '/nativeTab',
    component: NativeTabNavigatoLayout,
    children: [
      {
        path: 'lawyer',
        name: 'lawyer',
        // component: () => import('@/view/lawyer/Index.vue'),
        component: Lawyer
      },
    ]
  },
  // {
  //   path: '/lawyer',
  //   name: 'lawyer',
  //   component: () => import('@/view/lawyer/Index.vue')
  // },
  {
    path: '/lawyer/details/:id',
    name: '/lawyer/details',
    component: () => import('@/view/lawyer/Details.vue')
  },
  {
    path: '/lawyer/legalServices/:id',
    name: '/lawyer/legalServices',
    component: () => import('@/view/lawyer/LegalServices.vue')
  },
]

export default { routes }